document.addEventListener('DOMContentLoaded', () => {
  const initSwiper = (instance) => {
    if (!instance || instance.dataset.swiperInitialized === 'true' || typeof Swiper === 'undefined') return;

    new Swiper(instance, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 14,
      loop: false,
      centeredSlides: false,
      watchOverflow: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      initialSlide: 0,
      breakpoints: {
        640: {
          slidesPerView: 3,
        },
        960: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 5,
        },
      },
      navigation: {
        nextEl: `#next-${instance.getAttribute('id')}`,
        prevEl: `#prev-${instance.getAttribute('id')}`,
      },
    });

    instance.dataset.swiperInitialized = 'true';
  };

  const initVisibleSwipers = () => {
    const sections = document.querySelectorAll('[data-products-slider-2026="true"]');

    sections.forEach((section) => {
      section
        .querySelectorAll('[data-products-slider-2026-panel]:not([hidden]) .ProductsSlider__swiper')
        .forEach(initSwiper);
    });
  };

  window.initProductsSlider2026Swiper = initSwiper;

  if (typeof Swiper !== 'undefined') {
    initVisibleSwipers();
    return;
  }

  const checkSwiperLoadedInterval = setInterval(() => {
    if (typeof Swiper !== 'undefined') {
      initVisibleSwipers();
      clearInterval(checkSwiperLoadedInterval);
    }
  }, 200);
});
